import {
    GET_USER_FAILURE,
    GET_USER_SUCCESS,
    InitialBookingActions,
} from '../actions/InitialBookingActions';

const initialState = {
    appointmentTime: undefined,
    enableEmailConfirmationFixExperiment: false,
    enableShareInsuranceCardInBooking: true,
    isPatient: true,
    locationId: undefined,
    locationTimeZoneId: undefined,
    procedureId: undefined,
    professionalId: undefined,
};

export const initialBookingReducer = (state = initialState, action) => {
    switch (action.type) {
        case InitialBookingActions.SET_BOOKING_MODE:
            return {
                ...state,
            };
        case InitialBookingActions.INITIALIZE:
            return {
                ...state,
                ...action.payload,
            };

        case GET_USER_SUCCESS: {
            return {
                ...state,
                loggedInUser: action.user,
            };
        }
        case GET_USER_FAILURE: {
            return {
                ...state,
                loggedInUser: {},
            };
        }

        default:
            return state;
    }
};
